import React, {createContext, useReducer} from 'react'
import {ThinClientOverviewReducer} from "../reducer/ThinClientOverviewReducer";

export const ThinClientOverviewContext = createContext();

const ThinClientOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        thinClientDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(ThinClientOverviewReducer, data)
    return (
        <ThinClientOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </ThinClientOverviewContext.Provider>
    )
}

export default ThinClientOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/context/ThinClientOverviewContext.js